var _path, _path2, _g, _path3, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHyprEdgeManaged(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 24,
    viewBox: "0 0 139 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127 24C133.627 24 139 18.6274 139 12C139 5.37258 133.627 0 127 0C120.373 0 115 5.37258 115 12C115 18.6274 120.373 24 127 24Z",
    fill: "url(#paint0_linear_8028_2164)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127 0H14V24H127V0Z",
    fill: "url(#paint1_linear_8028_2164)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8028_2164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.4889 9.04321H31.93V15.082H31.4889V9.04321ZM27.4411 15.082H27V9.04321H27.4411V15.082ZM31.5408 12.2093H27.3892V11.8211H31.5408V12.2093Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4713 15.082V12.8908L35.5751 13.1755L33.0322 9.04321H33.5166L35.8259 12.7959H35.5837L37.893 9.04321H38.3514L35.8086 13.1755L35.9124 12.8908V15.082H35.4713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3066 15.082V9.04321H41.4775C41.9849 9.04321 42.4202 9.12373 42.7835 9.28476C43.1467 9.4458 43.4264 9.67872 43.6224 9.98353C43.8185 10.2826 43.9165 10.6478 43.9165 11.0791C43.9165 11.499 43.8185 11.8613 43.6224 12.1661C43.4264 12.4709 43.1467 12.7039 42.7835 12.8649C42.4202 13.0259 41.9849 13.1064 41.4775 13.1064H39.5487L39.7477 12.8994V15.082H39.3066ZM39.7477 12.9253L39.5487 12.7096H41.4775C42.129 12.7096 42.622 12.5687 42.9565 12.2869C43.2967 11.9993 43.4668 11.5968 43.4668 11.0791C43.4668 10.5558 43.2967 10.1532 42.9565 9.87138C42.622 9.58382 42.129 9.44004 41.4775 9.44004H39.5487L39.7477 9.22438V12.9253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4048 15.082V9.04321H47.5757C48.0832 9.04321 48.5185 9.12373 48.8818 9.28476C49.245 9.4458 49.5247 9.67872 49.7207 9.98353C49.9168 10.2826 50.0148 10.6478 50.0148 11.0791C50.0148 11.499 49.9168 11.8613 49.7207 12.1661C49.5247 12.4652 49.245 12.6981 48.8818 12.8649C48.5185 13.0259 48.0832 13.1064 47.5757 13.1064H45.647L45.8459 12.8994V15.082H45.4048ZM49.6083 15.082L48.0341 12.8908H48.5358L50.1099 15.082H49.6083ZM45.8459 12.9253L45.647 12.7182H47.5757C48.2273 12.7182 48.7203 12.5745 49.0547 12.2869C49.3949 11.9993 49.565 11.5968 49.565 11.0791C49.565 10.5558 49.3949 10.1532 49.0547 9.87138C48.7203 9.58382 48.2273 9.44004 47.5757 9.44004H45.647L45.8459 9.22438V12.9253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0186 11.8211H55.2966V12.2093H52.0186V11.8211ZM52.0705 14.6851H55.8069V15.082H51.6294V9.04321H55.6772V9.44004H52.0705V14.6851Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4155 15.082V9.04321H59.8113C60.4513 9.04321 61.0135 9.17262 61.4978 9.43142C61.9822 9.69022 62.357 10.0468 62.6222 10.5012C62.8932 10.9555 63.0287 11.476 63.0287 12.0626C63.0287 12.6492 62.8932 13.1697 62.6222 13.624C62.357 14.0784 61.9822 14.435 61.4978 14.6938C61.0135 14.9526 60.4513 15.082 59.8113 15.082H57.4155ZM57.8566 14.6851H59.7767C60.3475 14.6851 60.8434 14.573 61.2643 14.3487C61.6852 14.1244 62.011 13.8167 62.2416 13.4256C62.4723 13.0288 62.5876 12.5745 62.5876 12.0626C62.5876 11.5507 62.4723 11.0993 62.2416 10.7082C62.011 10.3114 61.6852 10.0008 61.2643 9.77649C60.8434 9.55219 60.3475 9.44004 59.7767 9.44004H57.8566V14.6851Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.147 15.125C66.6914 15.125 66.2705 15.0502 65.8842 14.9007C65.4979 14.7454 65.1606 14.5298 64.8722 14.2537C64.5897 13.9776 64.3706 13.6556 64.2149 13.2875C64.0592 12.9137 63.9814 12.5053 63.9814 12.0625C63.9814 11.6197 64.0592 11.2142 64.2149 10.8461C64.3706 10.4723 64.5926 10.1474 64.8809 9.8713C65.1692 9.59525 65.5036 9.38245 65.8842 9.23292C66.2705 9.07764 66.6943 9 67.1556 9C67.5938 9 68.0003 9.06901 68.3751 9.20704C68.7499 9.34507 69.0699 9.55211 69.3352 9.82817L69.0584 10.1215C68.7932 9.86268 68.502 9.67864 68.1848 9.56937C67.8735 9.46009 67.5333 9.40546 67.1643 9.40546C66.7722 9.40546 66.4089 9.4716 66.0745 9.60387C65.74 9.73615 65.4489 9.92306 65.2009 10.1646C64.953 10.4062 64.7598 10.688 64.6214 11.01C64.4888 11.3321 64.4225 11.6829 64.4225 12.0625C64.4225 12.4421 64.4888 12.7929 64.6214 13.115C64.7598 13.437 64.953 13.7188 65.2009 13.9604C65.4489 14.2019 65.74 14.3888 66.0745 14.5211C66.4089 14.6534 66.7722 14.7195 67.1643 14.7195C67.5217 14.7195 67.8591 14.6649 68.1762 14.5556C68.4991 14.4464 68.7932 14.2652 69.0584 14.0121L69.3092 14.3486C69.0382 14.6074 68.7124 14.8029 68.3319 14.9352C67.9571 15.0617 67.5621 15.125 67.147 15.125ZM68.8854 14.3055V12.0884H69.3092V14.3486L68.8854 14.3055Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6397 11.8211H74.9177V12.2093H71.6397V11.8211ZM71.6916 14.6851H75.428V15.082H71.2505V9.04321H75.2983V9.44004H71.6916V14.6851Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6763 15.082V9.04321H80.0442L82.8253 13.8828H82.6284L85.4009 9.04321H85.7603L85.7689 15.082H85.341L85.3325 9.70747H85.4523L82.8253 14.2797H82.6113L79.9758 9.70747H80.1041V15.082H79.6763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.856 15.082L89.6114 9.04321H90.0478L92.8031 15.082H92.3325L89.7312 9.31927H89.9194L87.3266 15.082H86.856ZM87.8657 13.3825L88.0112 13.0115H91.5966L91.7421 13.3825H87.8657Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8906 15.082V9.04321H94.2586L98.5286 14.5385H98.3318V9.04321H98.7682V15.082H98.4088L94.1302 9.5867H94.3271V15.082H93.8906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.8589 15.082L102.614 9.04321H103.051L105.806 15.082H105.335L102.734 9.31927H102.922L100.329 15.082H99.8589ZM100.869 13.3825L101.014 13.0115H104.599L104.745 13.3825H100.869Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.368 15.125C108.918 15.125 108.501 15.0502 108.119 14.9007C107.737 14.7454 107.403 14.5298 107.118 14.2537C106.838 13.9776 106.622 13.6556 106.467 13.2875C106.313 12.9137 106.236 12.5053 106.236 12.0625C106.236 11.6197 106.313 11.2142 106.467 10.8461C106.622 10.4723 106.841 10.1474 107.126 9.8713C107.412 9.59525 107.742 9.38245 108.119 9.23292C108.501 9.07764 108.921 9 109.377 9C109.81 9 110.213 9.06901 110.583 9.20704C110.954 9.34507 111.271 9.55211 111.533 9.82817L111.259 10.1215C110.997 9.86268 110.709 9.67864 110.395 9.56937C110.087 9.46009 109.751 9.40546 109.385 9.40546C108.998 9.40546 108.638 9.4716 108.307 9.60387C107.976 9.73615 107.688 9.92306 107.443 10.1646C107.198 10.4062 107.007 10.688 106.87 11.01C106.738 11.3321 106.673 11.6829 106.673 12.0625C106.673 12.4421 106.738 12.7929 106.87 13.115C107.007 13.437 107.198 13.7188 107.443 13.9604C107.688 14.2019 107.976 14.3889 108.307 14.5211C108.638 14.6534 108.998 14.7195 109.385 14.7195C109.739 14.7195 110.073 14.6649 110.387 14.5556C110.706 14.4464 110.997 14.2652 111.259 14.0121L111.508 14.3486C111.239 14.6074 110.917 14.8029 110.541 14.9352C110.17 15.0617 109.779 15.125 109.368 15.125ZM111.088 14.3055V12.0884H111.508V14.3486L111.088 14.3055Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.813 11.8211H117.056V12.2093H113.813V11.8211ZM113.865 14.6851H117.561V15.082H113.428V9.04321H117.433V9.44004H113.865V14.6851Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.152 15.082V9.04321H121.523C122.156 9.04321 122.712 9.17262 123.191 9.43142C123.67 9.69022 124.041 10.0468 124.304 10.5012C124.572 10.9555 124.706 11.476 124.706 12.0626C124.706 12.6492 124.572 13.1697 124.304 13.624C124.041 14.0784 123.67 14.435 123.191 14.6938C122.712 14.9526 122.156 15.082 121.523 15.082H119.152ZM119.589 14.6851H121.488C122.053 14.6851 122.544 14.573 122.96 14.3487C123.377 14.1244 123.699 13.8167 123.927 13.4256C124.155 13.0288 124.269 12.5745 124.269 12.0626C124.269 11.5507 124.155 11.0993 123.927 10.7082C123.699 10.3114 123.377 10.0008 122.96 9.77649C122.544 9.55219 122.053 9.44004 121.488 9.44004H119.589V14.6851Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8028_2164",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 24,
    height: 24
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 0H1V24H25V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8028_2164)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_8028_2164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 24C19.6274 24 25 18.6274 25 12C25 5.37258 19.6274 0 13 0C6.37258 0 1 5.37258 1 12C1 18.6274 6.37258 24 13 24Z",
    fill: "url(#paint2_linear_8028_2164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5622 7.66449C16.704 7.6848 16.8185 7.72223 16.9287 7.78532C17.1588 7.919 17.269 8.10079 17.3184 8.43015C17.331 8.51998 17.3573 8.92206 17.3646 9.14663C17.3846 9.73906 17.3951 13.1354 17.3804 14.1513C17.3709 14.8272 17.3604 15.0464 17.3289 15.1993C17.2249 15.704 16.9319 16.073 16.4466 16.3104C16.2061 16.4269 15.9835 16.4954 15.827 16.4975C15.6095 16.5007 15.578 16.4419 15.4835 15.8741C15.4257 15.5244 15.4215 15.5533 15.5455 15.5319C15.6505 15.5148 15.953 15.4078 16.0276 15.3629C16.2061 15.2538 16.3248 15.0603 16.3616 14.8133C16.371 14.7544 16.3731 13.9439 16.371 11.6811L16.3679 8.67358C16.3679 8.64628 16.3506 8.62198 16.3248 8.61302C16.2839 8.59804 16.2796 8.59911 16.1515 8.64937C16.0444 8.69215 14.8743 9.2942 13.7841 9.86846C13.1329 10.2107 12.3651 10.6096 12.2916 10.6416C12.1361 10.7112 12.0521 10.709 11.9513 10.6342C11.9051 10.601 11.8799 10.5647 11.7612 10.3625C11.6856 10.2342 11.6173 10.1091 11.6089 10.0856C11.5679 9.96684 11.611 9.85028 11.737 9.7412C11.8074 9.68025 11.8967 9.63212 12.7201 9.21293C13.7305 8.69857 15.0497 8.04518 15.3386 7.91472C15.8448 7.68587 16.1946 7.6153 16.5622 7.66449ZM10.526 7.76073C10.5796 7.78319 10.5995 7.82917 10.5922 7.91044C10.589 7.9468 10.5838 8.10079 10.5806 8.25371C10.5775 8.40663 10.5722 8.55206 10.5691 8.57666C10.5661 8.60286 10.5439 8.62264 10.5175 8.62264H10.4882C10.2025 8.62371 9.92628 8.8686 9.79289 9.24287C9.73197 9.41611 9.72672 9.46423 9.68891 10.2749C9.63114 11.4929 9.62589 11.7003 9.62589 12.6007C9.62589 13.5022 9.63639 13.8155 9.68891 14.5042C9.72462 14.9886 9.74563 15.0859 9.85906 15.2934C9.92418 15.4121 9.9935 15.4902 10.0691 15.5276C10.1227 15.5543 10.1395 15.5575 10.2288 15.5565C10.3117 15.5554 10.3422 15.549 10.4126 15.5222C10.4588 15.5051 10.5176 15.4784 10.5439 15.4634C10.7277 15.3586 13.5709 13.9096 13.969 13.7172C14.2074 13.6027 14.2977 13.5846 14.4279 13.6252C14.5382 13.6605 14.5876 13.7043 14.7357 13.9C14.8176 14.0091 14.8659 14.1021 14.8743 14.1716C14.8869 14.2786 14.8187 14.4058 14.7052 14.485C14.6475 14.5256 12.0931 15.8249 11.8253 15.95C11.5679 16.0708 11.4776 16.1179 11.2738 16.2377C10.9094 16.4526 10.6268 16.536 10.2655 16.536C9.8181 16.536 9.49145 16.4002 9.19841 16.0933C9.09443 15.9842 9.0083 15.857 8.93583 15.7072C8.85811 15.5447 8.8203 15.4271 8.78039 15.226C8.71422 14.8945 8.71632 14.9844 8.71632 12.0981C8.71632 10.4609 8.72052 9.43215 8.72682 9.36585C8.75728 9.0429 8.84025 8.76808 8.97679 8.53709C9.24147 8.09116 9.6637 7.81099 10.1721 7.74576C10.275 7.73293 10.4808 7.74148 10.526 7.76073ZM15.0497 10.6224C15.1222 10.6598 15.1611 10.7133 15.2083 10.8384C15.2325 10.9026 15.285 11.0106 15.3249 11.078C15.4541 11.2993 15.4573 11.4062 15.3354 11.4982C15.3092 11.5185 15.0508 11.6533 14.7619 11.7987C14.4721 11.9441 13.6118 12.3804 12.8493 12.7686C12.0868 13.1568 11.4303 13.4872 11.3894 13.5043C11.2707 13.5525 11.1741 13.5439 11.0711 13.4744C11.027 13.4445 10.8443 13.1889 10.7896 13.0819C10.7518 13.0092 10.7487 12.9943 10.7497 12.9215C10.7497 12.8531 10.755 12.8317 10.7833 12.7772C10.8264 12.6927 10.8716 12.6435 10.9493 12.5932C11.0554 12.5237 14.7977 10.6235 14.8607 10.6064C14.9279 10.5882 14.9962 10.5946 15.0497 10.6224Z",
    fill: "url(#paint3_linear_8028_2164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3626 5.41462C15.3626 6.82923 15.4773 6.82923 14.9871 6.82923C14.4968 6.82923 14.6118 6.82923 14.6118 5.41462C14.6118 4 14.508 4 14.9873 4C15.4661 4 15.3626 4 15.3626 5.41462Z",
    fill: "url(#paint4_linear_8028_2164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3626 5.41462C15.3626 6.82923 15.4773 6.82923 14.9871 6.82923C14.4968 6.82923 14.6118 6.82923 14.6118 5.41462C14.6118 4 14.508 4 14.9873 4C15.4661 4 15.3626 4 15.3626 5.41462Z",
    fill: "url(#paint5_linear_8028_2164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3626 5.41462C15.3626 6.82923 15.4773 6.82923 14.9871 6.82923C14.4968 6.82923 14.6118 6.82923 14.6118 5.41462C14.6118 4 14.508 4 14.9873 4C15.4661 4 15.3626 4 15.3626 5.41462Z",
    fill: "url(#paint6_linear_8028_2164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3626 5.41462C15.3626 6.82923 15.4773 6.82923 14.9871 6.82923C14.4968 6.82923 14.6118 6.82923 14.6118 5.41462C14.6118 4 14.508 4 14.9873 4C15.4661 4 15.3626 4 15.3626 5.41462Z",
    fill: "url(#paint7_linear_8028_2164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5042 5.41462C13.5042 6.82923 13.619 6.82923 13.1287 6.82923C12.6384 6.82923 12.7534 6.82923 12.7534 5.41462C12.7534 4 12.6496 4 13.1289 4C13.6077 4 13.5042 4 13.5042 5.41462Z",
    fill: "url(#paint8_linear_8028_2164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5042 5.41462C13.5042 6.82923 13.619 6.82923 13.1287 6.82923C12.6384 6.82923 12.7534 6.82923 12.7534 5.41462C12.7534 4 12.6496 4 13.1289 4C13.6077 4 13.5042 4 13.5042 5.41462Z",
    fill: "url(#paint9_linear_8028_2164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5042 5.41462C13.5042 6.82923 13.619 6.82923 13.1287 6.82923C12.6384 6.82923 12.7534 6.82923 12.7534 5.41462C12.7534 4 12.6496 4 13.1289 4C13.6077 4 13.5042 4 13.5042 5.41462Z",
    fill: "url(#paint10_linear_8028_2164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5042 5.41462C13.5042 6.82923 13.619 6.82923 13.1287 6.82923C12.6384 6.82923 12.7534 6.82923 12.7534 5.41462C12.7534 4 12.6496 4 13.1289 4C13.6077 4 13.5042 4 13.5042 5.41462Z",
    fill: "url(#paint11_linear_8028_2164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6463 5.41462C11.6463 6.82923 11.761 6.82923 11.2708 6.82923C10.7805 6.82923 10.8955 6.82923 10.8955 5.41462C10.8955 4 10.7917 4 11.271 4C11.7498 4 11.6463 4 11.6463 5.41462Z",
    fill: "url(#paint12_linear_8028_2164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6463 5.41462C11.6463 6.82923 11.761 6.82923 11.2708 6.82923C10.7805 6.82923 10.8955 6.82923 10.8955 5.41462C10.8955 4 10.7917 4 11.271 4C11.7498 4 11.6463 4 11.6463 5.41462Z",
    fill: "url(#paint13_linear_8028_2164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6463 5.41462C11.6463 6.82923 11.761 6.82923 11.2708 6.82923C10.7805 6.82923 10.8955 6.82923 10.8955 5.41462C10.8955 4 10.7917 4 11.271 4C11.7498 4 11.6463 4 11.6463 5.41462Z",
    fill: "url(#paint14_linear_8028_2164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6463 5.41462C11.6463 6.82923 11.761 6.82923 11.2708 6.82923C10.7805 6.82923 10.8955 6.82923 10.8955 5.41462C10.8955 4 10.7917 4 11.271 4C11.7498 4 11.6463 4 11.6463 5.41462Z",
    fill: "url(#paint15_linear_8028_2164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3626 18.5855C15.3626 20.0001 15.4773 20.0001 14.9871 20.0001C14.4968 20.0001 14.6118 20.0001 14.6118 18.5855C14.6118 17.1709 14.508 17.1709 14.9873 17.1709C15.4661 17.1709 15.3626 17.1709 15.3626 18.5855Z",
    fill: "url(#paint16_linear_8028_2164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3626 18.5855C15.3626 20.0001 15.4773 20.0001 14.9871 20.0001C14.4968 20.0001 14.6118 20.0001 14.6118 18.5855C14.6118 17.1709 14.508 17.1709 14.9873 17.1709C15.4661 17.1709 15.3626 17.1709 15.3626 18.5855Z",
    fill: "url(#paint17_linear_8028_2164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3626 18.5855C15.3626 20.0001 15.4773 20.0001 14.9871 20.0001C14.4968 20.0001 14.6118 20.0001 14.6118 18.5855C14.6118 17.1709 14.508 17.1709 14.9873 17.1709C15.4661 17.1709 15.3626 17.1709 15.3626 18.5855Z",
    fill: "url(#paint18_linear_8028_2164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3626 18.5855C15.3626 20.0001 15.4773 20.0001 14.9871 20.0001C14.4968 20.0001 14.6118 20.0001 14.6118 18.5855C14.6118 17.1709 14.508 17.1709 14.9873 17.1709C15.4661 17.1709 15.3626 17.1709 15.3626 18.5855Z",
    fill: "url(#paint19_linear_8028_2164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5042 18.5855C13.5042 20.0001 13.619 20.0001 13.1287 20.0001C12.6384 20.0001 12.7534 20.0001 12.7534 18.5855C12.7534 17.1709 12.6496 17.1709 13.1289 17.1709C13.6077 17.1709 13.5042 17.1709 13.5042 18.5855Z",
    fill: "url(#paint20_linear_8028_2164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5042 18.5855C13.5042 20.0001 13.619 20.0001 13.1287 20.0001C12.6384 20.0001 12.7534 20.0001 12.7534 18.5855C12.7534 17.1709 12.6496 17.1709 13.1289 17.1709C13.6077 17.1709 13.5042 17.1709 13.5042 18.5855Z",
    fill: "url(#paint21_linear_8028_2164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5042 18.5855C13.5042 20.0001 13.619 20.0001 13.1287 20.0001C12.6384 20.0001 12.7534 20.0001 12.7534 18.5855C12.7534 17.1709 12.6496 17.1709 13.1289 17.1709C13.6077 17.1709 13.5042 17.1709 13.5042 18.5855Z",
    fill: "url(#paint22_linear_8028_2164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5042 18.5855C13.5042 20.0001 13.619 20.0001 13.1287 20.0001C12.6384 20.0001 12.7534 20.0001 12.7534 18.5855C12.7534 17.1709 12.6496 17.1709 13.1289 17.1709C13.6077 17.1709 13.5042 17.1709 13.5042 18.5855Z",
    fill: "url(#paint23_linear_8028_2164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6463 18.5855C11.6463 20.0001 11.761 20.0001 11.2708 20.0001C10.7805 20.0001 10.8955 20.0001 10.8955 18.5855C10.8955 17.1709 10.7917 17.1709 11.271 17.1709C11.7498 17.1709 11.6463 17.1709 11.6463 18.5855Z",
    fill: "url(#paint24_linear_8028_2164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6463 18.5855C11.6463 20.0001 11.761 20.0001 11.2708 20.0001C10.7805 20.0001 10.8955 20.0001 10.8955 18.5855C10.8955 17.1709 10.7917 17.1709 11.271 17.1709C11.7498 17.1709 11.6463 17.1709 11.6463 18.5855Z",
    fill: "url(#paint25_linear_8028_2164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6463 18.5855C11.6463 20.0001 11.761 20.0001 11.2708 20.0001C10.7805 20.0001 10.8955 20.0001 10.8955 18.5855C10.8955 17.1709 10.7917 17.1709 11.271 17.1709C11.7498 17.1709 11.6463 17.1709 11.6463 18.5855Z",
    fill: "url(#paint26_linear_8028_2164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6463 18.5855C11.6463 20.0001 11.761 20.0001 11.2708 20.0001C10.7805 20.0001 10.8955 20.0001 10.8955 18.5855C10.8955 17.1709 10.7917 17.1709 11.271 17.1709C11.7498 17.1709 11.6463 17.1709 11.6463 18.5855Z",
    fill: "url(#paint27_linear_8028_2164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.39277 9.88328C7.78555 9.88328 7.78555 9.76572 7.78555 10.2682C7.78555 10.7707 7.78555 10.6528 6.39277 10.6528C5 10.6528 5 10.7592 5 10.2679C5 9.77724 5 9.88328 6.39277 9.88328Z",
    fill: "url(#paint28_linear_8028_2164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.39277 9.88328C7.78555 9.88328 7.78555 9.76572 7.78555 10.2682C7.78555 10.7707 7.78555 10.6528 6.39277 10.6528C5 10.6528 5 10.7592 5 10.2679C5 9.77724 5 9.88328 6.39277 9.88328Z",
    fill: "url(#paint29_linear_8028_2164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.39277 9.88328C7.78555 9.88328 7.78555 9.76572 7.78555 10.2682C7.78555 10.7707 7.78555 10.6528 6.39277 10.6528C5 10.6528 5 10.7592 5 10.2679C5 9.77724 5 9.88328 6.39277 9.88328Z",
    fill: "url(#paint30_linear_8028_2164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.39277 9.88328C7.78555 9.88328 7.78555 9.76572 7.78555 10.2682C7.78555 10.7707 7.78555 10.6528 6.39277 10.6528C5 10.6528 5 10.7592 5 10.2679C5 9.77724 5 9.88328 6.39277 9.88328Z",
    fill: "url(#paint31_linear_8028_2164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.39277 11.7876C7.78555 11.7876 7.78555 11.67 7.78555 12.1724C7.78555 12.675 7.78555 12.5571 6.39277 12.5571C5 12.5571 5 12.6634 5 12.1722C5 11.6815 5 11.7876 6.39277 11.7876Z",
    fill: "url(#paint32_linear_8028_2164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.39277 11.7876C7.78555 11.7876 7.78555 11.67 7.78555 12.1724C7.78555 12.675 7.78555 12.5571 6.39277 12.5571C5 12.5571 5 12.6634 5 12.1722C5 11.6815 5 11.7876 6.39277 11.7876Z",
    fill: "url(#paint33_linear_8028_2164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.39277 11.7876C7.78555 11.7876 7.78555 11.67 7.78555 12.1724C7.78555 12.675 7.78555 12.5571 6.39277 12.5571C5 12.5571 5 12.6634 5 12.1722C5 11.6815 5 11.7876 6.39277 11.7876Z",
    fill: "url(#paint34_linear_8028_2164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.39277 11.7876C7.78555 11.7876 7.78555 11.67 7.78555 12.1724C7.78555 12.675 7.78555 12.5571 6.39277 12.5571C5 12.5571 5 12.6634 5 12.1722C5 11.6815 5 11.7876 6.39277 11.7876Z",
    fill: "url(#paint35_linear_8028_2164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.39277 13.6916C7.78555 13.6916 7.78555 13.5741 7.78555 14.0765C7.78555 14.579 7.78555 14.4611 6.39277 14.4611C5 14.4611 5 14.5675 5 14.0762C5 13.5856 5 13.6916 6.39277 13.6916Z",
    fill: "url(#paint36_linear_8028_2164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.39277 13.6916C7.78555 13.6916 7.78555 13.5741 7.78555 14.0765C7.78555 14.579 7.78555 14.4611 6.39277 14.4611C5 14.4611 5 14.5675 5 14.0762C5 13.5856 5 13.6916 6.39277 13.6916Z",
    fill: "url(#paint37_linear_8028_2164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.39277 13.6916C7.78555 13.6916 7.78555 13.5741 7.78555 14.0765C7.78555 14.579 7.78555 14.4611 6.39277 14.4611C5 14.4611 5 14.5675 5 14.0762C5 13.5856 5 13.6916 6.39277 13.6916Z",
    fill: "url(#paint38_linear_8028_2164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.39277 13.6916C7.78555 13.6916 7.78555 13.5741 7.78555 14.0765C7.78555 14.579 7.78555 14.4611 6.39277 14.4611C5 14.4611 5 14.5675 5 14.0762C5 13.5856 5 13.6916 6.39277 13.6916Z",
    fill: "url(#paint39_linear_8028_2164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6064 9.88328C20.9998 9.88328 20.9998 9.76572 20.9998 10.2682C20.9998 10.7707 20.9998 10.6528 19.6064 10.6528C18.2129 10.6528 18.2129 10.7592 18.2129 10.2679C18.2129 9.77724 18.2129 9.88328 19.6064 9.88328Z",
    fill: "url(#paint40_linear_8028_2164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6064 9.88328C20.9998 9.88328 20.9998 9.76572 20.9998 10.2682C20.9998 10.7707 20.9998 10.6528 19.6064 10.6528C18.2129 10.6528 18.2129 10.7592 18.2129 10.2679C18.2129 9.77724 18.2129 9.88328 19.6064 9.88328Z",
    fill: "url(#paint41_linear_8028_2164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6064 9.88328C20.9998 9.88328 20.9998 9.76572 20.9998 10.2682C20.9998 10.7707 20.9998 10.6528 19.6064 10.6528C18.2129 10.6528 18.2129 10.7592 18.2129 10.2679C18.2129 9.77724 18.2129 9.88328 19.6064 9.88328Z",
    fill: "url(#paint42_linear_8028_2164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6064 9.88328C20.9998 9.88328 20.9998 9.76572 20.9998 10.2682C20.9998 10.7707 20.9998 10.6528 19.6064 10.6528C18.2129 10.6528 18.2129 10.7592 18.2129 10.2679C18.2129 9.77724 18.2129 9.88328 19.6064 9.88328Z",
    fill: "url(#paint43_linear_8028_2164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6064 11.7876C20.9998 11.7876 20.9998 11.67 20.9998 12.1724C20.9998 12.675 20.9998 12.5571 19.6064 12.5571C18.2129 12.5571 18.2129 12.6634 18.2129 12.1722C18.2129 11.6815 18.2129 11.7876 19.6064 11.7876Z",
    fill: "url(#paint44_linear_8028_2164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6064 11.7876C20.9998 11.7876 20.9998 11.67 20.9998 12.1724C20.9998 12.675 20.9998 12.5571 19.6064 12.5571C18.2129 12.5571 18.2129 12.6634 18.2129 12.1722C18.2129 11.6815 18.2129 11.7876 19.6064 11.7876Z",
    fill: "url(#paint45_linear_8028_2164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6064 11.7876C20.9998 11.7876 20.9998 11.67 20.9998 12.1724C20.9998 12.675 20.9998 12.5571 19.6064 12.5571C18.2129 12.5571 18.2129 12.6634 18.2129 12.1722C18.2129 11.6815 18.2129 11.7876 19.6064 11.7876Z",
    fill: "url(#paint46_linear_8028_2164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6064 11.7876C20.9998 11.7876 20.9998 11.67 20.9998 12.1724C20.9998 12.675 20.9998 12.5571 19.6064 12.5571C18.2129 12.5571 18.2129 12.6634 18.2129 12.1722C18.2129 11.6815 18.2129 11.7876 19.6064 11.7876Z",
    fill: "url(#paint47_linear_8028_2164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6064 13.6916C20.9998 13.6916 20.9998 13.5741 20.9998 14.0765C20.9998 14.579 20.9998 14.4611 19.6064 14.4611C18.2129 14.4611 18.2129 14.5675 18.2129 14.0762C18.2129 13.5856 18.2129 13.6916 19.6064 13.6916Z",
    fill: "url(#paint48_linear_8028_2164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6064 13.6916C20.9998 13.6916 20.9998 13.5741 20.9998 14.0765C20.9998 14.579 20.9998 14.4611 19.6064 14.4611C18.2129 14.4611 18.2129 14.5675 18.2129 14.0762C18.2129 13.5856 18.2129 13.6916 19.6064 13.6916Z",
    fill: "url(#paint49_linear_8028_2164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6064 13.6916C20.9998 13.6916 20.9998 13.5741 20.9998 14.0765C20.9998 14.579 20.9998 14.4611 19.6064 14.4611C18.2129 14.4611 18.2129 14.5675 18.2129 14.0762C18.2129 13.5856 18.2129 13.6916 19.6064 13.6916Z",
    fill: "url(#paint50_linear_8028_2164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6064 13.6916C20.9998 13.6916 20.9998 13.5741 20.9998 14.0765C20.9998 14.579 20.9998 14.4611 19.6064 14.4611C18.2129 14.4611 18.2129 14.5675 18.2129 14.0762C18.2129 13.5856 18.2129 13.6916 19.6064 13.6916Z",
    fill: "url(#paint51_linear_8028_2164)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8028_2164",
    x: 23,
    y: 9,
    width: 105.706,
    height: 14.125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8028_2164"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8028_2164",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_8028_2164",
    x: 1,
    y: 0,
    width: 24,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_8028_2164"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8028_2164",
    x1: 127,
    y1: 0,
    x2: 127,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E7EB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E7EB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8028_2164",
    x1: 14,
    y1: 24,
    x2: 127,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#16439E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#3E7EB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8028_2164",
    x1: 3.5,
    y1: 5,
    x2: 22.5,
    y2: 18.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.245439,
    stopColor: "#16439E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#6699C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8028_2164",
    x1: 13.0518,
    y1: 7.64966,
    x2: 13.0518,
    y2: 16.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6BDEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8028_2164",
    x1: 14.6001,
    y1: 6.82923,
    x2: 15.3743,
    y2: 6.82923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#16439E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#6699C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8028_2164",
    x1: 14.6001,
    y1: 6.82923,
    x2: 15.3743,
    y2: 6.82923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#16439E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#6699C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8028_2164",
    x1: 14.6001,
    y1: 6.82923,
    x2: 15.3743,
    y2: 6.82923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#16439E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#6699C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_8028_2164",
    x1: 14.9872,
    y1: 4,
    x2: 14.9872,
    y2: 6.82923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6BDEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_8028_2164",
    x1: 12.7417,
    y1: 6.82923,
    x2: 13.5159,
    y2: 6.82923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#16439E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#6699C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_8028_2164",
    x1: 12.7417,
    y1: 6.82923,
    x2: 13.5159,
    y2: 6.82923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#16439E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#6699C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_8028_2164",
    x1: 12.7417,
    y1: 6.82923,
    x2: 13.5159,
    y2: 6.82923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#16439E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#6699C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_8028_2164",
    x1: 13.1288,
    y1: 4,
    x2: 13.1288,
    y2: 6.82923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6BDEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_8028_2164",
    x1: 10.8838,
    y1: 6.82923,
    x2: 11.658,
    y2: 6.82923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#16439E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#6699C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_8028_2164",
    x1: 10.8838,
    y1: 6.82923,
    x2: 11.658,
    y2: 6.82923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#16439E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#6699C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_8028_2164",
    x1: 10.8838,
    y1: 6.82923,
    x2: 11.658,
    y2: 6.82923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#16439E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#6699C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_8028_2164",
    x1: 11.2709,
    y1: 4,
    x2: 11.2709,
    y2: 6.82923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6BDEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_8028_2164",
    x1: 14.6001,
    y1: 20.0001,
    x2: 15.3743,
    y2: 20.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#16439E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#6699C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_8028_2164",
    x1: 14.6001,
    y1: 20.0001,
    x2: 15.3743,
    y2: 20.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#16439E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#6699C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_8028_2164",
    x1: 14.6001,
    y1: 20.0001,
    x2: 15.3743,
    y2: 20.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#16439E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#6699C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_8028_2164",
    x1: 14.9872,
    y1: 17.1709,
    x2: 14.9872,
    y2: 20.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6BDEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_8028_2164",
    x1: 12.7417,
    y1: 20.0001,
    x2: 13.5159,
    y2: 20.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#16439E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#6699C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_8028_2164",
    x1: 12.7417,
    y1: 20.0001,
    x2: 13.5159,
    y2: 20.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#16439E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#6699C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_8028_2164",
    x1: 12.7417,
    y1: 20.0001,
    x2: 13.5159,
    y2: 20.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#16439E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#6699C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_8028_2164",
    x1: 13.1288,
    y1: 17.1709,
    x2: 13.1288,
    y2: 20.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6BDEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_8028_2164",
    x1: 10.8838,
    y1: 20.0001,
    x2: 11.658,
    y2: 20.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#16439E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#6699C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_8028_2164",
    x1: 10.8838,
    y1: 20.0001,
    x2: 11.658,
    y2: 20.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#16439E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#6699C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_8028_2164",
    x1: 10.8838,
    y1: 20.0001,
    x2: 11.658,
    y2: 20.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#16439E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#6699C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_8028_2164",
    x1: 11.2709,
    y1: 17.1709,
    x2: 11.2709,
    y2: 20.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6BDEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_8028_2164",
    x1: 5,
    y1: 10.6648,
    x2: 7.78555,
    y2: 10.6648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#16439E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#6699C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_8028_2164",
    x1: 5,
    y1: 10.6648,
    x2: 7.78555,
    y2: 10.6648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#16439E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#6699C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_8028_2164",
    x1: 5,
    y1: 10.6648,
    x2: 7.78555,
    y2: 10.6648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#16439E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#6699C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_8028_2164",
    x1: 6.39278,
    y1: 9.87134,
    x2: 6.39278,
    y2: 10.6648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6BDEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_8028_2164",
    x1: 5,
    y1: 12.5691,
    x2: 7.78555,
    y2: 12.5691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#16439E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#6699C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_8028_2164",
    x1: 5,
    y1: 12.5691,
    x2: 7.78555,
    y2: 12.5691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#16439E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#6699C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_8028_2164",
    x1: 5,
    y1: 12.5691,
    x2: 7.78555,
    y2: 12.5691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#16439E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#6699C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_8028_2164",
    x1: 6.39278,
    y1: 11.7756,
    x2: 6.39278,
    y2: 12.5691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6BDEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_8028_2164",
    x1: 5,
    y1: 14.4731,
    x2: 7.78555,
    y2: 14.4731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#16439E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#6699C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_8028_2164",
    x1: 5,
    y1: 14.4731,
    x2: 7.78555,
    y2: 14.4731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#16439E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#6699C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_8028_2164",
    x1: 5,
    y1: 14.4731,
    x2: 7.78555,
    y2: 14.4731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#16439E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#6699C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_8028_2164",
    x1: 6.39278,
    y1: 13.6797,
    x2: 6.39278,
    y2: 14.4731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6BDEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_8028_2164",
    x1: 18.2129,
    y1: 10.6648,
    x2: 20.9998,
    y2: 10.6648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#16439E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#6699C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_8028_2164",
    x1: 18.2129,
    y1: 10.6648,
    x2: 20.9998,
    y2: 10.6648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#16439E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#6699C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_8028_2164",
    x1: 18.2129,
    y1: 10.6648,
    x2: 20.9998,
    y2: 10.6648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#16439E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#6699C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_8028_2164",
    x1: 19.6063,
    y1: 9.87134,
    x2: 19.6063,
    y2: 10.6648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6BDEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_8028_2164",
    x1: 18.2129,
    y1: 12.5691,
    x2: 20.9998,
    y2: 12.5691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#16439E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#6699C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_8028_2164",
    x1: 18.2129,
    y1: 12.5691,
    x2: 20.9998,
    y2: 12.5691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#16439E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#6699C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_8028_2164",
    x1: 18.2129,
    y1: 12.5691,
    x2: 20.9998,
    y2: 12.5691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#16439E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#6699C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_8028_2164",
    x1: 19.6063,
    y1: 11.7756,
    x2: 19.6063,
    y2: 12.5691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6BDEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_8028_2164",
    x1: 18.2129,
    y1: 14.4731,
    x2: 20.9998,
    y2: 14.4731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#16439E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#6699C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_8028_2164",
    x1: 18.2129,
    y1: 14.4731,
    x2: 20.9998,
    y2: 14.4731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#16439E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#6699C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_8028_2164",
    x1: 18.2129,
    y1: 14.4731,
    x2: 20.9998,
    y2: 14.4731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#16439E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#6699C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_8028_2164",
    x1: 19.6063,
    y1: 13.6797,
    x2: 19.6063,
    y2: 14.4731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6BDEA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyprEdgeManaged);
export default __webpack_public_path__ + "static/media/HyprEdge-Managed.f4e331a4f05722739cce10e3916f4d69.svg";
export { ForwardRef as ReactComponent };